/* import __COLOCATED_TEMPLATE__ from './lucky-losers-results-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();